import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-200/70 border border-background-300/50 rounded-xl p-6 md:p-10">
            <div className="flex-shrink-0">
              <img
                src={appData.appImage}
                alt="每日大赛黑料 APP"
                className="w-48 md:w-56 h-auto rounded-lg"
              />
            </div>

            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
                {appData.tag}
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-3">
                {appData.title}
              </h2>
              <p className="text-foreground-500 text-sm leading-relaxed mb-5">
                {appData.desc}
              </p>

              <div className="grid grid-cols-2 gap-3 mb-6">
                {appData.features.map((f) => (
                  <div key={f} className="flex items-center gap-2 text-sm text-foreground-300">
                    <i className="ri-checkbox-circle-fill text-accent-400"></i>
                    {f}
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-center lg:justify-start gap-4">
                <button className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-md text-sm font-medium transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill text-base"></i>
                  App Store
                </button>
                <button className="px-5 py-2.5 bg-background-300 hover:bg-background-400 text-foreground-200 rounded-md text-sm font-medium transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer border border-background-500/50">
                  <i className="ri-android-fill text-base"></i>
                  安卓下载
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}